import { removeEmptyFields } from "src/helpers/workflowStepIteratorHelper";
import axiosInstance from "./axiosInstance";

export const workflowStepIterator = async ({
    access_token,
    node_id = null,
    body = {},
    query = {},
    headers = {},
    action_index = null,
    step = null,
    constextOfStep = null,
}) => {
    const request_headers = {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${access_token}`
    };

    const isBodyForGeolocationRequest = (body && Object.keys(body).length === 1 && body.fromGeolocation === true)

    let payload = [removeEmptyFields({
        node_id,
        payload: removeEmptyFields({ body, query, headers }),
        action_index,
    })];
    if (isBodyForGeolocationRequest && payload[0]?.payload) {
        payload[0].payload.body = {};
    }
    payload = payload.filter(item => Object.keys(item).length > 0);
    const context = removeEmptyFields({ step, ...constextOfStep });

    return await axiosInstance.post(
        `/api/service-manager/workflow/next`,
        {
            payload,
            context
        },
        {
            headers: request_headers,
        }
    );
};